import { RouteObject } from "react-router-dom";
import Feature_SecondaryChannel from "./Feature_SecondaryChannel";
import { R_SecondaryChannelRoutes } from "../../utils/Routes";

const SecondaryChannelRoutes: RouteObject[] = [
  {
    path: R_SecondaryChannelRoutes.fromSecondaryChannel,
    element: <Feature_SecondaryChannel />,
  },
];

export default SecondaryChannelRoutes;
